export default __webpack_public_path__ + "static/media/hand.3d396ced.svg";